import React from 'react';

export const ShutterCenterOpening = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 106.9 77.8"
      width="85"
      {...props}
    >
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M10 5.3h86.8v58.8H10z" />
        <path d="M96.9 64.9H10c-.4 0-.8-.3-.8-.8V5.3c0-.4.3-.8.8-.8h86.8c.4 0 .8.3.8.8v58.8c.1.4-.3.8-.7.8zm-86.1-1.6h85.3V6H10.8v57.3z" />
      </g>
      <path
        d="M106.2 69.3H.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h105.4c.4 0 .7.3.7.7.1.4-.2.7-.6.7z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M6 1.7l42.9 8.4.2 66.7L6 67.7z" />
        <path
          d="M49.9 77.8L5.3 68.4V.7l44.4 8.7.2 68.4zM6.8 67l41.5 8.7-.2-65L6.8 2.6V67z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 9.5l34 6.8V21l-34-6.7z" />
        <path
          d="M45 21.6l-34.8-6.9V9.1L45 15.9v5.7zm-34-7.7l33.2 6.6v-3.9L11 10v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 14.3l34 6.7v4.8l-34-6.8z" />
        <path
          d="M45 26.3l-34.8-7v-5.6l34.8 7v5.6zm-34-7.6l33.3 6.6v-3.9L11 14.8v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 19l34 6.8v4.8l-34-6.8z" />
        <path
          d="M45 31.1l-34.9-7v-5.6l34.8 7 .1 5.6zm-34-7.7l33.3 6.7v-3.9L11 19.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 23.8l34 6.8v4.8l-34-6.9z" />
        <path
          d="M45 35.9l-34.9-7v-5.6l34.9 7v5.6zm-34-7.7l33.3 6.7V31L11 24.3v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 28.5l34 6.9.1 4.8-34.1-6.9z" />
        <path
          d="M45.1 40.7l-34.9-7.1V28l34.9 7v5.7zM11 32.9l33.3 6.8v-3.9L11 29.1v3.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 33.3l34.1 6.9V45l-34.1-6.9z" />
        <path
          d="M45.1 45.5l-34.9-7.1v-5.6l34.9 7.1v5.6zM11 37.7l33.3 6.8v-3.9L11 33.8v3.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M10.6 38.1L44.7 45v4.8l-34.1-7z" />
          <path
            d="M45.1 50.3l-34.9-7.2v-5.6l34.9 7.1v5.7zM11 42.5l33.3 6.8v-3.9L11 38.6v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 42.8l34.1 7v4.8l-34.1-7z" />
          <path
            d="M45.1 55.1l-34.9-7.2v-5.6l34.9 7.2v5.6zM11 47.2l33.3 6.9v-3.9L11 43.3v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 47.6l34.1 7v4.8l-34.1-7.1z" />
          <path
            d="M45.1 59.9l-34.9-7.2v-5.6l34.9 7.2v5.6zM11 52l33.3 6.9V55L11 48.1V52z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 52.4l34.1 7.1v4.8l-34.1-7.2z" />
          <path
            d="M45.1 64.8l-34.9-7.3v-5.6l34.9 7.2v5.7zm-34.1-8l33.3 6.9v-3.9L11 52.9v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 57.1l34.1 7.2v4.8l-34.1-7.2z" />
          <path
            d="M45.1 69.6l-34.9-7.3v-5.6L45.1 64v5.6zm-34.1-8l33.3 7v-3.9l-33.3-7v3.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M26.5 12.7l2.3.4.1 52.6-2.3-.4z" />
      </g>
      <g>
        <path fill="#233762" d="M56.2 9.7l43.9-8v66l-43.9 9.1z" />
        <path
          d="M100.9 68.4l-45.5 9.4V9L100.9.7v67.7zM57 75.8L99.4 67V2.6L57 10.4v65.4z"
          fill="#fff"
        />
        <path fill="#233762" d="M61 15.9l34.8-6.4v4.7L61 20.7z" />
        <path
          d="M96.2 14.6l-35.6 6.7v-5.7L96.2 9v5.6zm-34.8 5.6l34-6.4V10l-34 6.3v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M61 20.7l34.8-6.5V19L61 25.6z" />
        <path
          d="M96.2 19.3L60.6 26v-5.7l35.6-6.7v5.7zM61.4 25l34-6.4v-3.9l-34 6.4V25z"
          fill="#fff"
        />
        <path fill="#233762" d="M61 25.6L95.8 19v4.7L61 30.4z" />
        <path
          d="M96.2 24.1l-35.6 6.8v-5.7l35.6-6.7v5.6zm-34.8 5.8l34-6.5v-3.9l-34 6.4v4z"
          fill="#fff"
        />
        <path fill="#233762" d="M61 30.4l34.8-6.6v4.7L61 35.2z" />
        <path
          d="M96.2 28.9l-35.6 6.9v-5.7l35.6-6.8v5.6zm-34.8 5.8l34-6.5v-3.9l-34 6.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M61 35.2l34.8-6.7v4.8L61 40z" />
        <path
          d="M96.2 33.6l-35.6 6.9v-5.7L96.2 28v5.6zm-34.8 5.9l34-6.6V29l-34 6.6v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M61 40l34.8-6.7V38L61 44.9z" />
        <path
          d="M96.2 38.4l-35.6 7v-5.7l35.6-6.9v5.6zm-34.8 6l34-6.7v-3.9l-34 6.6v4z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M61 44.9L95.8 38v4.8L61 49.7z" />
          <path
            d="M96.2 43.2l-35.6 7v-5.7l35.6-7v5.7zm-34.8 6l34-6.7v-3.9l-34 6.7v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61 49.7l34.8-6.9v4.8L61 54.5z" />
          <path
            d="M96.2 47.9L60.6 55v-5.7l35.6-7v5.6zM61.4 54l34-6.8v-3.9l-34 6.7v4z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61 54.5l34.8-6.9v4.7l-34.8 7z" />
          <path
            d="M96.2 52.7l-35.6 7.2v-5.7l35.6-7.1v5.6zm-34.8 6.1l34-6.8v-3.9l-34 6.8v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61 59.4l34.8-7v4.7L61 64.2z" />
          <path
            d="M96.2 57.5l-35.6 7.2V59l35.6-7.2v5.7zm-34.8 6.2l34-6.9v-3.9l-34 6.8v4z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61 64.2l34.8-7.1v4.8L61 69z" />
          <path
            d="M96.2 62.2l-35.6 7.3v-5.7l35.6-7.2v5.6zm-34.8 6.3l34-6.9v-3.9l-34 6.9v3.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M77.5 12.9l2.3-.5v52.8l-2.3.4z" />
      </g>
    </svg>
  );
};
